import React from 'react';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import styles from './cancel_watcher_creation.module.scss';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';

type Props = {
  tooltipId: string;
  deleteWatcher: () => void;
};

export class CancelWatcherCreationButton extends React.Component<Props> {
  render() {
    const { tooltipId, deleteWatcher } = this.props;
    return (
      <>
        <button
          data-tip="Supprimer l'alerte"
          data-for={tooltipId}
          className={`${styles.button} button`}
          type="button"
          onClick={deleteWatcher}
        >
          <MaterialIcon name="notifications" className={styles.icon} />
          <FormattedMessage id="watchers/components/cancel-watcher-creation/CancelWatcherCreationButton.tsx/1" />
        </button>
        <Tooltip id={tooltipId} effect="solid" />
      </>
    );
  }
}
